import React from 'react';
import ReactDOM from 'react-dom';
import Background from './components/Background';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Background />
  </React.StrictMode>,
  document.getElementById('root')
);